import { AccountVersion, DeployType } from '../config/config.service';

export enum ParameterPlaceholders {
    REF = '$ref',
    REDIRECT_URL = '$redirect_url',
    LANG = '$lang',
    PARTNER_ID = '$partner_id',
    EMAIL = '$email',
    CLIENT_ID = '$client_id',
    PROVIDER_ID = '$provider_id'
};

export interface LoginConfigParameters {
    user?: ParameterPlaceholders;
    adobe_mc_ref?: ParameterPlaceholders;
    redirect_url?: ParameterPlaceholders;
    lang?: ParameterPlaceholders;
    partner_id?: ParameterPlaceholders;
    des?: string;
    provider_id?: string;
};

export interface ConfigBaseParameters {
    nimbusClientId?: string;
    partner_id?: string;
    siteName?: string;
    siteUrl?: string;
    cookiesDomain?: string;
    loginServer?: string;
    loginPath?: string;
    loginParams?: LoginConfigParameters;
    logoutServer?: string;
    logoutPath?: string;
    logoutParams?: LoginConfigParameters;
    registerServer?: string;
    home?: boolean;
};

export interface ConfigServiceInterface extends ConfigBaseParameters {
    useClientIds?: boolean;
    clientIds?: any;
    loginUserToken?: string;
    outletEventsTracking?: boolean;
    type: DeployType;
    manufacturerName: string;
    manufacturerNameBox: string;
    defaultTheme: string;
    themes: boolean;
    pathImages: string;
    pathIcons: string;
    logo: string;
    manufacturerLogo: string;
    avangateFrameParam: string;
    mainPage: string;
    idTPIframeLink: string;
    idTPIframeOrigin: string;
    cookieConsent: boolean;
    boxName?: string;
    nimbusServer: string;
    connectNimbusServer: string;
    katastifServer: string;
    atoServer: string;
    securePassServer: string;
    gmailAuth: {
        clientId: string;
    };
    outlookAuth: {
        clientId: string;
    };
    loginCreateServer: string;
    loginChangeEmail: string;
    externalAccountLink: string;
    externalPasswordAccountLink: string;
    externalAuthenticationAccountLink: string;
    parentalNccDefaultAvatars: string;
    googleMapsApi: string;
    reloginParams: LoginConfigParameters;
    loginRedirectUrlType: string;
    autolookupPath: string;
    defaultLoginUserTokenName: string
    loginUserTokenName?: string;
    loginRequestType?: any;
    registerPath: string;
    ts_trial_id: string;
    registerParams: LoginConfigParameters;
    notifications: boolean;
    premium: boolean;
    privacyTabs: {
        activity: boolean;
        footprint: boolean;
        breaches: boolean;
        impersonations: boolean;
        brokers: boolean;
        education: boolean;
        history: boolean;
        monitor: boolean;
        remedies: boolean;
    };
    privacyChat: boolean;
    subscriptions: boolean;
    subscriptionsTabs: {
        billing : boolean;
        invoices: boolean;
        payments: boolean;
    };
    autoRenewalFlow: boolean;
    subscriptionsSdk: boolean;
    multiplePaymentCards: boolean;
    quickActions: {
        malwareScan: boolean;
        antitheft: boolean;
        optimizer: boolean;
        vulnerabilityScan: boolean;
        scan: boolean;
    };
    offers: boolean;
    support: boolean;
    community: boolean;
    thirdparty: boolean;
    terms: boolean;
    poweredBy: boolean;
    dashboard: boolean;
    omniture: boolean;
    devicesTab: boolean;
    business: {
        dashboard: boolean;
    };
    dashboardCards: {
        recommendations: boolean;
        securityNews: boolean;
        appBanner: boolean;
    };
    referral: boolean;
    info: boolean;
    onboardingMSP: boolean;
    qrCode: boolean;
    family: {
        dashboard: true
    };
    automaticTrialActivation: boolean;
    internalSupport: boolean;
    externalSupport: boolean;
    externalSupportLink: string;
    supportCards: {
        phone: boolean;
        email: boolean;
        search: boolean;
    };
    homeSections: {
        capabilities: boolean;
        capabilitiesList: {
            deviceProtection: boolean;
            remoteActions: boolean;
            installProtection: boolean;
            manageServices: boolean;
            parentalControl: boolean;
            industryInsights: boolean;
        };
        products: boolean;
        appBanner: boolean;
    };
    hasCustomBuyLink: boolean;
    account: {
        profile: boolean;
        sessions: boolean;
        settings: boolean;
        change_password: boolean;
        admin_password: boolean;
        delete_account: boolean;
        change_email: boolean;
        version: AccountVersion
    };
    activationButtonDoRedirect: boolean;
    serviceDetailsLinks: {
        website?: boolean;
        features: boolean;
        requirements: boolean;
        userGuide: boolean;
    };
    passwordManagerCards: {
        needHelp: boolean;
    };
    vpnCards: {
        upgrade: boolean;
        userGuide: boolean;
    };
    atoThreatsTabs: {
        devices: boolean;
        emailProtection: boolean;
    };
    downloadElements: {
        footer: boolean;
        headerLogo: boolean;
        benefitsLogo: boolean;
        commonHelpSection: boolean;
    };
    onBoardingSection: {
        backgroundLogo: boolean,
    };
    parentalNccElements: {
        contentFiltering: {
            module: boolean;
            topics: boolean;
            safeSearch: boolean;
            youtubeRestricted: boolean;
        };
        dtl: {
            module: boolean;
            reward: boolean;
            needMoreTime: boolean;
        };
        routines: {
            module: boolean;
        };
        dashboard: {
            module: boolean;
            location: boolean;
        };
        blockedContent: {
            hasCategories: boolean;
            hasTopics: boolean;
            hasWebsites: boolean;
        };
        pin: boolean;
    };
    ato: boolean;
    meta: boolean;
    security: boolean;
    securityTabs: {
        overview: boolean;
        webmailProtection: boolean;
    };
    installProtection : {
        showLogo: boolean;
        logoPath?: string;
        customLogoPath?: string;
    };
    katastifService: boolean;
    sentryAngular: boolean;
    sentryConnect: boolean;
    rights: {
        buy: boolean;
        buyMoreSlots: boolean;
        activateRedeem: boolean;
    };
    pwaSettings: {
        manifestByOs: {
            windows: string;
            android: string;
            mac: string;
            ios: string;
            osx: string;
        };
        manifestPath: string;
        serviceWorkerPath: string;
    },
    removeSwitchAndUpgradeSecurePassBanner: boolean
};

export interface ConfigJsInterface extends ConfigBaseParameters {
    type: number;
    adb: number;
    showLoginV2?: boolean;
};